var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        "padding-left": "24px",
        "padding-right": "24px",
        "padding-top": "12px",
        "padding-bottom": "12px",
        background: "white",
        "border-radius": "50px",
        border: "1px #C3C3C3 solid",
        "justify-content": "flex-start",
        "align-items": "center",
        gap: "5px",
        display: "flex"
      }
    },
    [
      _c("span", { staticClass: "text-muted" }, [
        _vm._v(_vm._s(_vm.index + 1))
      ]),
      _c("div", {
        staticStyle: {
          width: "16px",
          height: "16px",
          padding: "10px",
          "border-radius": "34px",
          "flex-direction": "column",
          "justify-content": "center",
          "align-items": "center",
          gap: "10px",
          display: "inline-flex"
        },
        style: { background: _vm.model.color }
      }),
      _c(
        "div",
        {
          staticStyle: {
            color: "#11291B",
            "font-size": "16px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "21.60px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" " + _vm._s(_vm.model.text) + " ")]
      ),
      _c(
        "div",
        {
          staticStyle: {
            width: "16px",
            height: "16px",
            "justify-content": "center",
            "align-items": "center",
            display: "flex"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "pointer",
              on: {
                click: function($event) {
                  return _vm.onDeleteHandler()
                }
              }
            },
            [
              _c("i", {
                staticClass: "fal fa-times-circle",
                staticStyle: { width: "16px", height: "16px", color: "#C9545E" }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }